import { populate } from "populate";

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "c4eb6c9f-02f9-4245-a515-12ff748d3dc8",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "13504b35-7cdb-4681-8edd-79bc7ccf59bf",
      type: "Container",
      name: "particlesContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "c4eb6c9f-02f9-4245-a515-12ff748d3dc8",
      data: ""
    },
    {
      id: "33daf05f-fa96-4558-ba97-d1f4f1f9ddb5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "none",
      parent: "c4eb6c9f-02f9-4245-a515-12ff748d3dc8",
      data: ""
    },
    {
      id: "92a20052-8d98-42a1-8aab-088095cec639",
      type: "Sprite",
      name: "ftuxArrow",
      nameSpace: "",
      className: "",
      x: -136,
      y: -110,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -33,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ftux_arrow",
      parent: "c4eb6c9f-02f9-4245-a515-12ff748d3dc8",
      data: ""
    },
    {
      id: "cb85b140-e99b-4e20-9f15-9537d25529da",
      type: "Sprite",
      name: "harvestButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_medium_blue_2",
      parent: "33daf05f-fa96-4558-ba97-d1f4f1f9ddb5",
      data: ""
    },
    {
      id: "1f62c68f-9e43-472b-8ffc-f78abaa2abaf",
      type: "Sprite",
      name: "decor",
      nameSpace: "",
      className: "",
      x: 0,
      y: -46,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "button_decor",
      parent: "33daf05f-fa96-4558-ba97-d1f4f1f9ddb5",
      data: ""
    },
    {
      id: "23276a61-bc94-4375-8470-5ec4f57156f9",
      type: "Text",
      name: "harvestText",
      nameSpace: "",
      className: "",
      x: -20,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Harvest",
      localize: true,
      maxWidth: 147,
      maxHeight: 76,
      maxFontSize: 42,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "white",
        stroke: "#b73814",
        strokeThickness: 5,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "miter",
        miterLimit: 2,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "cb85b140-e99b-4e20-9f15-9537d25529da",
      data: ""
    },
    {
      id: "2719c759-847f-4d3c-9d71-d60e1e518600",
      type: "Sprite",
      name: "coin",
      nameSpace: "",
      className: "",
      x: 70,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "coin_medium",
      parent: "cb85b140-e99b-4e20-9f15-9537d25529da",
      data: ""
    }
  ],
  version: "1.0.x"
} as const;

export class HarvestButtonLayout {
  static raw = raw;
  root: PIXI.Container;
  particlesContainer: PIXI.Container;
  harvestButton: PIXI.Sprite;
  harvestText: PIXI.Text;
  coin: PIXI.Sprite;
  decor: PIXI.Sprite;
  ftuxArrow: PIXI.Sprite;

  constructor() {
    populate(this, raw);
  }
}
